export const SLIDE_SWITCH_TRANSITION_SECOND = 0.3;
